export default __webpack_public_path__ + "static/media/fullScreenIcon.cb04da1a.svg";